<template>
  <van-popup v-model="showBind" class="backRect" @closed="onClosed">
    <TopBar :pagetitle="title" :is-left-self="true" @leftClick="onBack" />
    <div class="inputRect">
      <FieldSelect v-model="postData.courseTypeId" :list="courseList" label="课程" placeholder="请选择课程" style="border-bottom:1px solid #ebedf0;" />
      <van-field
        v-model="startDate"
        label="开课日期"
        required
        readonly
        placeholder="请选择开课日期"
        @click="showDateSelect=true"
      />

      <FieldSelect v-model="postData.countryId" :list="countryList" label="国家" placeholder="请选择国家" style="border-bottom:1px solid #ebedf0;" />
      <van-field
        v-model="postData.city"
        required
        clearable
        label="所在城市"
        placeholder="请输入所在城市"
      />
      <van-field
        v-model="postData.address"
        clearable
        label="地点"
        placeholder="请输入地点"
      />

      <van-field
        v-model="postData.name"
        clearable
        label="班级名称"
        placeholder="请输入班级名称"
      />
      <van-field
        v-model="postData.info"
        clearable
        label="备注"
        placeholder="请输入备注"
      />

      <div class="buttonRect">
        <van-button type="primary" size="large" :loading="buttonLoading" :color="GetColorMain()" @click="onAddClass">添加班级</van-button>
      </div>
    </div>
    <div v-if="showType==='reg'" class="regAbout">
      绑定手机号码即可关联预定行程订单,接收行程通知等。
    </div>
    <dateSelect v-model="showDateSelect" :max-date="maxDate" :min-date="minDate" :default-date="startDate" @onChange="onDateSelect" />
  </van-popup>

</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { Button, Popup, Field, Toast } from 'vant'
import { formatDate, MyNotify, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { getAidaConfig } from '@/utils/baseData'
import FieldSelect from '@/components/FieldSelect'
import dateSelect from '@/components/dateSelect'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Toast.name]: Toast,
    TopBar,
    FieldSelect,
    dateSelect
  },
  props: {
    // eslint-disable-next-line
    value:undefined,
    // eslint-disable-next-line
    showType:undefined
  },
  data() {
    return {
      title: '创建班级',
      showBind: false,
      buttonLoading: false,
      postData: {
        address: '',
        city: '',
        countryId: '',
        courseTypeId: '',
        info: '',
        name: '',
        startDate: undefined
      },
      startDate: undefined,
      minDate: new Date(),
      maxDate: new Date(),
      showDateSelect: false,
      courseList: [],
      countryList: []
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.showBind = true
        this.init()
      } else {
        this.showBind = false
      }
    }
  },
  created() {

  },
  methods: {
    formatDate,
    MyNotify,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    init() {
      setTimeout(() => {
        getAidaConfig((data) => {
          this.courseList = []
          data.courseList.forEach(item => {
            this.courseList.push({ text: item.k, value: item.v })
          })
          this.countryList = []
          data.countryList.forEach(item => {
            this.countryList.push({ text: item.k, value: item.v })
          })
          this.postData.courseTypeId = '3'
          this.postData.countryId = '45'
          var dt = new Date().setFullYear((new Date().getFullYear() + 1))
          var dtMin = new Date().setFullYear((new Date().getFullYear() - 1))
          this.maxDate = new Date(dt)
          this.minDate = new Date(dtMin)
          this.onDateSelect(new Date())
        })
      }, 1)
    },
    onClosed() {
      this.$emit('input', false)
    },
    onBack() {
      this.showBind = false
      return true
    },
    onAddClass() {
      this.buttonLoading = true
      request({
        url: '/Pro/AddClassAida',
        method: 'post',
        data: this.postData
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }

        this.showBind = false
        if (response.data && response.data !== 'null') {
          this.$router.push('/pro/aidaClass/' + response.data)
          MyNotify('success', '添加班级成功')
        } else {
          MyNotify('success', '添加班级成功,请手动刷新列表!', 10000)
        }
      })
    },
    onDateSelect(date) {
      console.log('onDateSelect', date)
      this.postData.startDate = date
      if (date) {
        this.startDate = formatDate(date, 'yyyy/MM/dd')
      } else {
        this.startDate = undefined
      }
    }
  }
}
</script>
<style scoped>
.backRect{
    width: 100vw;
    height: 100vh;
    background-color: #F1f1f1;
}
.inputRect{
  margin: 1em 1em 0 1em;
  background-color: #fff;
  border-radius: 0.5em;
  overflow: hidden;
}
.regAbout{
  margin:1em 2em;
  color: #999;
  font-size: 0.8em;
}
</style>
